import React from 'react'
import Carousel from 'react-bootstrap/Carousel';
import "./BlogCarousel.scss"
import { useState } from 'react';
import { Card } from 'react-bootstrap';
import useFirestore from '../hooks/useFirestore';
function BlogCarousel() {
    const [index, setIndex] = useState(0);
    const { docs } = useFirestore('Posts', 5);

    const handleSelect = (selectedIndex) => {
        setIndex(selectedIndex);
    };

    const sanitizeText = (html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        return doc.body.textContent || '';
    };
    return (
        <div className='BlogCarousel'>
            <Carousel className='BlogCar' activeIndex={index} onSelect={handleSelect} controls={false} indicators={true}>
                {docs.map((post) => (
                    <Carousel.Item className='carouselItem' key={post.id}>
                        <Card className="bg-dark text-white">
                            <div className="carouselImage-cont">
                            {post.PhotoUrl ? (
                                <Card.Img src={post.PhotoUrl}  className='carouselImage' />
                                ) : null}
                            </div>
                            <Card.ImgOverlay className='text-jol'>
                                <div className="TextContain">
                                    <div className="TextContain-inner">
                                        <Card.Title className='text-enlarge' >{post.Title}</Card.Title>
                                    </div>
                                    <Card.Text className='cardTitText Content' dangerouslySetInnerHTML={{ __html: sanitizeText(post.Content) }}>
                                    </Card.Text>
                                </div>

                            </Card.ImgOverlay>
                        </Card>
                    </Carousel.Item>
                ))}
            </Carousel>
        </div >
    )
}

export default BlogCarousel
